import { render } from "./SideBarMenu.vue?vue&type=template&id=7674b00a"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"

import "./SideBarMenu.vue?vue&type=style&index=0&id=7674b00a&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__